<template>
  <div class="text-center">
    <v-dialog v-model="$store.state.Loader" hide-overlay persistent width="300">
      <v-card :color="getThemeColor" dark>
        <v-card-text>
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: "Fetching data",
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
};
</script>
